import { apiClient } from '@/config/api';

export type DashboardCommonAreasAttribute = {
  id: number;
  name: string;
  uuid: string | null;
  type: { id: number; code: string | null; name: string | null; unit: string | null } | null;
  currentValue: string | null;
  currentValueTs: string | null; // ISO string
};

export type DashboardCommonAreasDevice = {
  id: number;
  name: string | null;
  box: { id: number; name: string | null } | null;
  attributes: DashboardCommonAreasAttribute[];
};

export type DashboardCommonAreasBuilding = {
  project: { id: number; title: string; logo?: string | null };
  building: { id: number; name: string | null; code: string | null };
  devices: DashboardCommonAreasDevice[];
};

export const dashboardCommonAreasService = {
  async getCommonAreas(): Promise<DashboardCommonAreasBuilding[]> {
    const { data } = await apiClient.get<DashboardCommonAreasBuilding[]>('/dashboard/parties-communes');
    return data;
  },
};

